module.exports = __webpack_public_path__ + "img/betsss.3f520675.png";